module.exports = __webpack_public_path__ + "img/logo-deep.b0ed9f98.png";